import { useState } from "react";
import BottomNav from "../components/BottomNav";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { objectsApi } from "../services/api";
import { CategorySelect, ColorSelect } from "../components/SelectField";
import toast from "react-hot-toast";

const T = { night:"#0A1F3D", royal:"#1263B0", cyan:"#1CBCD3", gold:"#C9922A",
  white:"#fff", bg:"#F7F9FC", border:"#E2E8F0" };

export default function DeclareFound() {
  const { t } = useTranslation();
  const nav = useNavigate();
  const [loading, setLoading] = useState(false);
  const [form, setForm] = useState({
    category:"", objectName:"", description:"", mainColor:"",
    brandModel:"", foundLocation:"", foundDate:""
  });

  const set = (k,v) => setForm(f=>({...f,[k]:v}));

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const r = await objectsApi.declareFound(form);
      toast.success(t("declare_found.success") + " " + (r.data?.data?.reference || ""));
      nav("/dashboard");
    } catch { toast.error(t("declare_found.error")); }
    finally { setLoading(false); }
  };

  const canSubmit = form.category && form.objectName && form.description
    && form.foundLocation && form.foundDate;

  return (
    <div style={{ minHeight:"100vh", background:T.bg, fontFamily:"'DM Sans',sans-serif" }}>
      <div style={{ background:`linear-gradient(135deg,${T.gold},#A67820)`,
        padding:"20px 24px", display:"flex", alignItems:"center", gap:"16px" }}>
        <button onClick={()=>nav("/dashboard")}
          style={{ background:"transparent", border:"none", color:T.white,
            fontSize:"20px", cursor:"pointer" }}>←</button>
        <div>
          <h1 style={{ color:T.white, fontSize:"17px", fontWeight:700, margin:0 }}>
            {t("declare_found.title")}
          </h1>
          <p style={{ color:"rgba(255,255,255,0.7)", fontSize:"12px", margin:0 }}>
            {t("declare_found.subtitle")}
          </p>
        </div>
        <span style={{ marginLeft:"auto", background:"rgba(255,255,255,0.2)", color:T.white,
          fontSize:"11px", fontWeight:700, padding:"4px 10px", borderRadius:"20px" }}>
          {t("declare_found.free_badge")}
        </span>
      </div>

      <div style={{ maxWidth:"600px", margin:"0 auto", padding:"24px 24px 80px" }}>
        <div style={{ background:"#E0F7FA", borderLeft:"4px solid #1CBCD3",
          padding:"12px 16px", borderRadius:"0 12px 12px 0",
          fontSize:"13px", color:"#0E8FA3", marginBottom:"20px" }}>
          {t("declare_found.good_faith")}
        </div>

        <div style={{ marginBottom:"16px" }}>
          <label style={{ fontSize:"13px", fontWeight:600, color:"#334155",
            marginBottom:"6px", display:"block" }}>
            {t("declare_found.category")}
          </label>
          <CategorySelect value={form.category} onChange={e=>set("category",e.target.value)} />
        </div>

        <div style={{ marginBottom:"16px" }}>
          <label style={{ fontSize:"13px", fontWeight:600, color:"#334155",
            marginBottom:"6px", display:"block" }}>
            {t("declare_found.object_name")}
          </label>
          <input value={form.objectName} onChange={e=>set("objectName",e.target.value)}
            placeholder={t("declare_found.object_placeholder")} spellCheck={false}
            style={{ width:"100%", padding:"12px 16px", border:"1.5px solid #E2E8F0",
              borderRadius:"12px", fontSize:"14px", outline:"none", boxSizing:"border-box" }}/>
        </div>

        <div style={{ marginBottom:"16px" }}>
          <label style={{ fontSize:"13px", fontWeight:600, color:"#334155",
            marginBottom:"6px", display:"block" }}>
            {t("declare_found.description")}
          </label>
          <textarea value={form.description} onChange={e=>set("description",e.target.value)}
            placeholder={t("declare_found.description_placeholder")}
            rows={4} spellCheck={false}
            style={{ width:"100%", padding:"12px 16px", border:"1.5px solid #E2E8F0",
              borderRadius:"12px", fontSize:"14px", outline:"none",
              boxSizing:"border-box", resize:"none" }}/>
        </div>

        <div style={{ marginBottom:"16px" }}>
          <label style={{ fontSize:"13px", fontWeight:600, color:"#334155",
            marginBottom:"6px", display:"block" }}>
            {t("declare_found.main_color")}
          </label>
          <ColorSelect value={form.mainColor} onChange={e=>set("mainColor",e.target.value)} />
        </div>

        <div style={{ marginBottom:"16px" }}>
          <label style={{ fontSize:"13px", fontWeight:600, color:"#334155",
            marginBottom:"6px", display:"block" }}>
            {t("declare_found.found_location")}
          </label>
          <input value={form.foundLocation} onChange={e=>set("foundLocation",e.target.value)}
            placeholder={t("declare_found.location_placeholder")} spellCheck={false}
            style={{ width:"100%", padding:"12px 16px", border:"1.5px solid #E2E8F0",
              borderRadius:"12px", fontSize:"14px", outline:"none", boxSizing:"border-box" }}/>
        </div>

        <div style={{ marginBottom:"24px" }}>
          <label style={{ fontSize:"13px", fontWeight:600, color:"#334155",
            marginBottom:"6px", display:"block" }}>
            {t("declare_found.found_date")}
          </label>
          <input type="date" value={form.foundDate} onChange={e=>set("foundDate",e.target.value)}
            style={{ width:"100%", padding:"12px 16px", border:"1.5px solid #E2E8F0",
              borderRadius:"12px", fontSize:"14px", outline:"none", boxSizing:"border-box" }}/>
        </div>

        <button onClick={handleSubmit} disabled={!canSubmit||loading}
          style={{ width:"100%", padding:"16px",
            background:canSubmit&&!loading?T.gold:"#E2E8F0",
            color:canSubmit&&!loading?T.white:"#94A3B8",
            border:"none", borderRadius:"12px", fontWeight:700,
            cursor:canSubmit&&!loading?"pointer":"not-allowed", fontSize:"15px" }}>
          {loading?t("common.loading"):t("declare_found.submit")}
        </button>
      </div>
      <BottomNav />
    </div>
  );
}
